/*
 * View for the contents button on the dashboard
 */

define([
  "marionette",
  "modules/dashboard/dashboardContents/template/dashboardContentsTemplate.html",
], function (Marionette, DashboardContentsTemplate) {
  var DashboardContentsView = {};

  DashboardContentsView.dashboardContentsView = Marionette.ItemView.extend({
    template: DashboardContentsTemplate,
    modelEvents: {
      sync: "render",
    },
    triggers: {
      "click #dashboardNewCount": "click:new:content",
      "click #dashboardModifiedCount": "click:modified:content",
      "click #dashboardMissingCount": "click:missing:content",
    },
  });

  return DashboardContentsView;
});
